import React from 'react';
import { Box, Container, CssBaseline, Stack, Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import PageHeading from '../../global/header/PageHeading';

const RegistrationSuccessful = () => {
  return (
    <>
      <PageHeading pageTitle="Registration successful" />
      <Container maxWidth="lg" className="selfRegistrationContainer">
        <Box textAlign="center" mb={3}>
          <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }} justifyContent="center">
            <Grid item xs="12" sm="5" md="5" marginBottom={3}>
              <Box mb={3} className="thanksMsgBox">
                <Typography variant="h6" mb={3}>
                  08x-xxx-xxxxx Registration is complete on January 1, 2022.
                </Typography>
                <Typography variant="h6">
                  You have already applied for the main package (Super Value Promotion). You can now
                  apply for additional packages.
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Box Container justifyContent="center" alignItems="center">
            <Link to="/in/selfregistration" className="mainBtn btnLink">
              Return to main menu
            </Link>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default RegistrationSuccessful;
